import { render } from "./index.vue?vue&type=template&id=770f88b2"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=770f88b2&lang=scss"
script.render = render

export default script